import { GridController, gridTpl } from '../../../../common/grid/grid.controller';
import { getAccountDocuments, getDocumentTypes } from '../administration-accounts.actions';

class AdministrationAccountsDocumentsGridController extends GridController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService) {
        super($ngRedux, $state, NavigationService);
        this.$ngRedux = $ngRedux;
    }

    $onInit() {
        this.module = 'administration';
        this.autoload = false;
        this.filterTemplate = './administration-accounts-documents-grid-filter.html';

        this.columns = [
            {title: '#',                            mapper: null},
            {title: 'Room Name',                    mapper: 'roomName'},
            {title: 'Document Number',              mapper: 'docNum'},
            {title: 'Document Type',                mapper: 'type.name'},
            {title: 'Document URI',                 mapper: 'file-download'},
            {title: 'Expiry Date',                  mapper: 'expires'}
        ];

        this.unsubscribe = this.$ngRedux.connect(
            this.mapState().bind(this),
            { getAccountDocuments, getDocumentTypes }
        )(this);

        this.dataAction = this.getAccountDocuments;
        this.exportService = this.getAccountDocuments;
        this.filter.identifier = this.identifier;
        this.getDocumentTypes('administrationAccountsRoomDocument');
        this.init();
    }

    $onDestroy() {
        this.destroy();
    }
}

export const administrationAccountsDocumentsGrid = {
    bindings: {
        identifier: '@',
        title: '@',
        onSelect: '&',
        onRemove: '&',
        onReset: '&'
    },
    controller: AdministrationAccountsDocumentsGridController,
    ...gridTpl
};
